/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import TextAreaWithCount from "components/text-area/text-area-with-count";
import { isEmptyObject } from "utils/object.utils";
import { getErrorMessage } from "pages/story-editor/utils";

import { t } from "i18n";

const Summary = ({ value, spec, onChange, errors, disabled = false }) => {
  return (
    <TextAreaWithCount
      label={t("story-editor.inspector.social-description")}
      maxValue={isEmptyObject(spec) ? 140 : spec.validations["hard-limit"]}
      value={value}
      onChange={onChange}
      errorMessage={getErrorMessage(errors)}
      disabled={disabled}
    />
  );
};
export default Summary;
